// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"80f18833","360":"d0513d0f","453":"127be8e2","597":"db77da11","713":"8243ae28","890":"5aaedd60"}[chunkId] + ".chunk.js";
};